import "./src/styles/global.css"

import React from "react";
import { IntlProvider } from "gatsby-plugin-intl";
 
export const wrapRootElement = ({ element }) => {
  return <IntlProvider>{element}</IntlProvider>;
};